import React from "react";

const SkeletonAccordionLoading = () => {
  return (
    <ul className="list-none m-0 py-2">
      {[...Array(5)].map((_, index) => (
        <li
          key={index}
          className="animate-pulse bg-gray-200 rounded-md h-6 w-full mb-2 flex justify-between items-center py-2  "
        ></li>
      ))}
    </ul>
  );
};

export default SkeletonAccordionLoading;
